import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function AddressProvider({ children }) {
  useInjectSaga({ key: 'addressProvider', saga });
  useInjectReducer({ key: 'addressProvider', reducer });

  return React.Children.only(children);
}

AddressProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as useAddress } from './useAddress';
export default compose(withConnect, memo)(AddressProvider);
